import api from "@/libs/axios";
import * as ep from "../../../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
    form: {},
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    form(state) {
      return state.form;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setForm(state, val) {
      state.form = val;
    },
  },
  actions: {
    async deleteForm({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        const res = await api.delete(ep.FORM_BY_ID(id));
        dispatch("handleResponse", res);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },

    async getFormById({ commit }, id) {
      commit("setLoading", true);
      try {
        const res = await api.get(ep.FORM_BY_ID(id));
        if (hasError(res.status)) throw res.status;
        commit("setForm", res.data.data);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },
    handleResponse({ commit, dispatch }, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        throw res.status;
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      }
    },
  },
};
